import { useChains } from "@opensea/app-kit"
import { useCallback } from "react"
import { useAddress } from "../../polychain/hooks/useAddress"
import { useRequireChain } from "../../polychain/hooks/useRequireChain"
import { useTrackError } from "../../providers/TrackErrorProvider"
import { FlowActions } from "../../stores/flowStore"
import type { Item } from "../../types"
import { useConnectFlow } from "./useConnectFlow"

export const useCreateOfferFlow = () => {
  const address = useAddress()
  const connect = useConnectFlow()

  const { getChainId } = useChains()
  const { requireChain } = useRequireChain()

  const trackError = useTrackError()

  return useCallback(
    (items: Item[]) => {
      const openCreateOfferFlow = async () => {
        const allSameChain = items.every(
          item => item.chain.identifier === items[0].chain.identifier,
        )

        if (!allSameChain) {
          throw new Error(
            "All items for createOfferFlow call must all be from the same chain.",
          )
        }

        try {
          await requireChain(getChainId(items[0].chain.identifier))
        } catch (error) {
          trackError(error as Error)
          // Continue despite error since flow will handle switching chains later
        }
        FlowActions.startFlow({
          type: "create-offer",
          items,
        })
      }

      if (address) {
        openCreateOfferFlow()
      } else {
        connect({ onConnected: openCreateOfferFlow })
      }
    },
    [address, requireChain, getChainId, trackError, connect],
  )
}
